import React from "react";
import { Box, Skeleton, Card, CardContent } from "@mui/material";

const SuccessfulPaymentSkeleton = () => {
  return (
    <Box p={3}>
      {/* Title Section */}
      <Box textAlign="center" mb={4}>
        <Skeleton variant="circular" width={80} height={80} sx={{ mx: "auto", mb: 2 }} />
        <Skeleton variant="text" width="40%" height={40} sx={{ mx: "auto" }} />
        <Skeleton variant="text" width="60%" sx={{ mx: "auto" }} />
      </Box>

      {/* Reference */}
      <Box textAlign="center" mb={3}>
        <Skeleton variant="text" width={120} sx={{ mx: "auto" }} />
        <Skeleton variant="text" width={200} sx={{ mx: "auto" }} />
      </Box>

      {/* Card */}
      <Card sx={{ maxWidth: 600, mx: "auto", borderRadius: 3 }}>
        <CardContent>
          {/* Header */}
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="30%" />
          </Box>

          {/* Rows */}
          {[1, 2, 3].map((item) => (
            <Box key={item} display="flex" justifyContent="space-between" mb={2}>
              <Skeleton variant="text" width="40%" />
              <Skeleton variant="text" width="30%" />
            </Box>
          ))}

          {/* Note */}
          <Skeleton variant="text" width="100%" />
        </CardContent>
      </Card>

      {/* Button */}
      <Box textAlign="center" mt={4}>
        <Skeleton variant="rectangular" width={220} height={45} sx={{ mx: "auto", borderRadius: 2 }} />
      </Box>
    </Box>
  );
};

export default SuccessfulPaymentSkeleton;